
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 7h26c1.093 0 2 .907 2 2v14c0 1.093-.907 2-2 2H2c-1.093 0-2-.907-2-2V9c0-1.093.907-2 2-2zm0 2v14h26V9H2zm2 2h2v2H4v-2zm4 0h2v2H8v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zM4 15h4v2H4v-2zm6 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h4v2h-4v-2zM4 19h4v2H4v-2zm6 0h10v2H10v-2zm12 0h4v2h-4v-2z"}})])
          )
        }
      }
    